module.exports = __webpack_public_path__ + "img/change.b5acd3cf.png";